import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from '../../../layout/LayoutAside';
import UIDatePicker from 'components/datepicker';
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UISelect from 'components/selectbox/UISelect';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import { CodeData } from "common/codedata/source/CodeDataSource";
import paramStore from "common/page/store/ParamStore";
import UIUtils from "utils/UIUtils";
import StringUtil from "utils/StringUtil";

function ContentsContainer() {
	const location = useLocation();
	//const receivedData = paramStore.getParam("adm7100");
	let receivedData = (location.state as any)?.data;
	const history = useHistory();
		
	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
	const [StartDate, setStartDate] = useState(new Date());
	const [EndDate, setEndDate] =useState(new Date());
	const [LAST_STATUS, setLAST_STATUS] = useState('');
	const [CORP_NM, setCORP_NM] = useState('');
	const [TSK_NM, setTSK_NM] = useState('');
	const [BIZ_CD, setBIZ_CD] = useState('');
	const [BIZ_SHORT_NM, setBIZ_SHORT_NM] = useState<CodeData[]>();
		
	const [totalRowCnt_modal, setTotalRowCnt_modal] = useState(0);
	const [showRowCnt_modal, setShowRowCnt_modal] = useState(20); //기본 row count
	const [SUM_IN_AMT_modal, setSUM_IN_AMT_modal] = useState('');
	const [SUM_OUT_AMT_modal, setSUM_OUT_AMT_modal] = useState('');
	const [TOTAL_SUM_AMT_modal, setTOTAL_SUM_AMT_modal] = useState('');
	const [BIZ_NO_modal, SetBIZ_NO_modal] = useState('');
	const [CORP_NM_modal, SetCORP_NM_modal] = useState('');
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [dateNum,setDateNum] = useState(0); 
	const paramJson = useRef<string>("");
	
    //let SheetData = {};
	let pageNum = useRef<number>(1);

	const rowCnt = useRef<string>("20");
	const totalCnt = useRef<string>("");
	
	function LAST_STATUS_DISPFormula(fr) {
		var color = '';
		
		if (fr.Row.LAST_STATUS === 10) {
	    	color = '#0000FF';
	  	} else if (fr.Row.LAST_STATUS === 11) {
	    	color = '#FF0000';
	  	} else if (fr.Row.LAST_STATUS === 15) {
		    color = '#009900';
	  	}
	
	  	return color;
	}
	
	var ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				/*
	            "SearchMode": 0,
	            "SectionCanResize": 1,
	            "CanSort": false,
	            "CanColMove": false,
	            "CanColResize": false,
	            "HeaderCheck": 0,
	            "CanEdit": 0,
	            "Hover": 0,
	            "Height": 500,
	            "PageLength": 20,
	            "InfoRowConfig": {
	            },
	            */   
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"HeaderCheck": 1,
				"HeaderCheckMode": 1,
				"CustomScroll": 3,
				"Height": "759px",		   
				         		
			},
			
			"Def": {
			    "Row": {
			    	"CanFormula": 1,
					"CalcOrder": "LAST_STATUS_DISPTextColor,chkType,chkVisible"
		    	},
    		},			
				//틀고정 좌측 컬럼 설정
			"Cols": [
	            {"Header": "NO",		"Type": "Int",	"Name": "SEQ",				"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {
					"Header": {
						"Value": "",
						"HeaderCheck": 1, //헤더(Header)에 체크박스 생성
						"IconAlign": "Center" //체크박스 가운데 정렬
					},
					"Type" : "Bool",
					"Name": "chk",
					"RelWidth": 1,
					"Align": "Center",
					"CanEdit": 1,
					"BoolIcon": 4,
					TypeFormula:function(fr){
						if(fr.Row["LAST_STATUS"] !== 11){
							return "Text";
				      	}
					},					
					VisibleFormula:function(fr){
						if(fr.Row["LAST_STATUS"] !== 11){
					       return 0;
				      	}
					}					
				},
	            {"Header": "사업명",		"Type": "Text",	"Name": "BIZ_NM",			"RelWidth": 1.5,	"Align": "left",	"CanEdit": 0},
	            {"Header": "출연기업",		"Type": "Text",	"Name": "CORP_NM",			"RelWidth": 1.5,	"Align": "left",	"CanEdit": 0},
	            {"Header": "과제명",		"Type": "Text",	"Name": "TSK_NM",			"RelWidth": 2.5,	"Align": "left",	"CanEdit": 0},
	            {"Header": "과제번호",		"Type": "Text",	"Name": "TSK_REQ_NO_FMT",	"RelWidth": 1.4,	"Align": "Center",	"CanEdit": 0},
	            {"Header": "사용용도",		"Type": "Text",	"Name": "FUN_PUR_USE_NM",	"RelWidth": 1.8,	"Align": "left",	"CanEdit": 0},
	            {"Header": "과제분야(대분류)","Type": "Text","Name": "BIZ_KIND_NM1",	"RelWidth": 1.8,	"Align": "left",	"CanEdit": 0},
	            {"Header": "지급신청번호",	"Type": "Text",	"Name": "PAY_REQ_NO_DISP",	"RelWidth": 1.4,	"Align": "Center",	"CanEdit": 0},
	            {"Header": "수행기업",		"Type": "Int",	"Name": "PERF_CNT",			"RelWidth": 1, 		"Align": "Right",	"CanEdit": 0, "Format": "#,##0"},
	            {"Header": "중소기업",		"Type": "Int",	"Name": "SM_CNT",			"RelWidth": 1,		"Align": "Right",	"CanEdit": 0, "Format": "#,##0"},
	            {"Header": "지급신청금액",	"Type": "Int",	"Name": "REGI_AMT",			"RelWidth": 1.5,	"Align": "Right",	"CanEdit": 0, "Format": "#,###"},
	            {
					"Header": "결재상태",
					"Type": "Text",
					"Name": "LAST_STATUS_DISP",
					"RelWidth": 1, 
					"Align": "Center",
					"CanEdit": 0,
					"TextColorFormula": LAST_STATUS_DISPFormula
				},
	            {"Header": "지급건",		"Type": "Int",	"Name": "NOR_CNT",			"RelWidth": 0.7,		"Align": "Right",	"CanEdit": 0, "Format": "#,###"},
	            {
					"Header": "미지급금액",
					"Type": "Int",	
					"Name": "NON_AMT",			
					"RelWidth": 1.5, 	
					"Align": "Right",	
					"CanEdit": 0,
					"TextColor": "#FF0000", 
					"Format": "#,###",
				},
				{"Header": "세금계산서\n첨부여부","Type": "Text",	"Name": "TAXBILL_YN_DISP",	"RelWidth": 1,	"Align": "Center",	"CanEdit": 0},
	            {"Header": "등록자",			"Type": "Text",	"Name": "PERSON_NM",		"RelWidth": 1, 	"Align": "Center",	"CanEdit": 0},
	            {"Header": "등록일",			"Type": "Text",	"Name": "REG_DATETIME",		"RelWidth": 1.8,"Align": "Center",	"CanEdit": 0},
	            {"Header": "PAY_REQ_NO",	"Type": "Text",	"Name": "PAY_REQ_NO",		"RelWidth": 1, 	Visible : 0}, //지급신청번호
	            {"Header": "REG_DATE",		"Type": "Text",	"Name": "REG_DATE",			"RelWidth": 1, 	Visible : 0}, //결재등록일자
	            {"Header": "REG_NUM",		"Type": "Text",	"Name": "REG_NUM",			"RelWidth": 1, 	Visible : 0}, //결재등록일련번호
	            {"Header": "LAST_STATUS",	"Type": "Text",	"Name": "LAST_STATUS",		"RelWidth": 1, 	Visible : 0},
	            {"Header": "LAST_SAN_YN",	"Type": "Text",	"Name": "LAST_SAN_YN",		"RelWidth": 1, 	Visible : 0},
	            {"Header": "EXECUTE_YN",	"Type": "Text",	"Name": "EXECUTE_YN",		"RelWidth": 1, 	Visible : 0}, 
	            {"Header": "APPR_STAP_NO",	"Type": "Text",	"Name": "APPR_STAP_NO",		"RelWidth": 1, 	Visible : 0},
	            {"Header": "BIZ_NO",		"Type": "Text",	"Name": "BIZ_NO",			"RelWidth": 1, 	Visible : 0},
	            
            ],
       
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				onClickSearch('init');
				
			},
			
			onDblClick:function(evtParam){
				var sheet = evtParam.sheet;
				var row = sheet.getFocusedRow();
				sheet.selectRow( row, 1);
				
				//onClickDetail();
				// @ts-ignore
				var vPAY_REQ_NO = row["PAY_REQ_NO"];
				var vREG_DATE = row["REG_DATE"];
				var vREG_NUM = row["REG_NUM"];
				var vLAST_STATUS = row["LAST_STATUS"];
				var vLAST_SAN_YN = row["LAST_SAN_YN"];
				var vEXECUTE_YN = row["EXECUTE_YN"];
				var vAPPR_STAP_NO = row["APPR_STAP_NO"];
				var vBIZ_NO = row["BIZ_NO"];
				/*
				var sStartDate = StartDate;
				var sEndDate = EndDate;
				var sLAST_STATUS = LAST_STATUS;
				var sBIZ_CD = BIZ_CD;
				var sCORP_NM = CORP_NM;
				var sTSK_NM = TSK_NM;
				*/		
			    let dataToSend = {vPAY_REQ_NO, vREG_DATE, vREG_NUM, vLAST_STATUS, vLAST_SAN_YN, vEXECUTE_YN, vAPPR_STAP_NO,vBIZ_NO};
				paramStore.setParam("adm7101", dataToSend);
		
			    // 다른 페이지로 이동하면서 데이터 전달
			    history.push({
					pathname: 'adm7101',
			    });
			    				
		    },
		    
			onRenderFinish  :function(evtParam){
				if(receivedData !== undefined ){
					if(receivedData.PARAM_DATA !== undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
						pageMove(receivedData.PARAM_PAGE);
					}
				}
				
			},
		    
			onAfterGotoPage:function (evtParam) {
				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				pageNum.current = page; //페이지 번호 저장용
				paramSetting();
				
		        //@ts-ignore
				if (currentPage !== -1 && currentPage !== page) {
					makePageIndex(page);
				}

			},	

			onAfterSort:function(evtParam){
				var sheet = evtParam.sheet;
				
				sheet.goToPageByIndex(1);
				if(sheet.getShownRows().length !== 0){
					sheet.focus(sheet.getShownRows()[0], "SEQ");
				}
			},
			

		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			if(receivedData !== undefined ){
				if(receivedData.PARAM_DATA !== undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
					options.Cfg.PageLength = receivedData.PARAM_ROW_CNT;
				}
			}

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'Main_sheet', // 생성할 시트의 id
				el: 'ap_trade_mast', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
				
			});
			
			//@ts-ignore
			window.currentPage = -1;
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.Main_sheet.down2Excel({fileName: "결재함_"+today+".xlsx", SheetDesign:3, excelRowHeight:16.5, excelFontSize:10, downCols: "Visible"});
			
		},
		
		'data':[]
	}
		
	const paramSetting = () => {
		let PARAM_DATA = paramJson.current;
		let PARAM_PAGE = pageNum.current;
		let PARAM_ROW_CNT = rowCnt.current;
		let dataToSend = {PARAM_DATA, PARAM_PAGE, PARAM_ROW_CNT};

		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm7100',
			state: { data: dataToSend }
		});
	}

	function dateToStr(dateText) {
		if(dateText == null) return '';
		let year = dateText.substring(0,4);
		let month = dateText.substring(4,6);
		let day = dateText.substring(6,8);

		return year+'-'+month+'-'+day;
	}

    async function SetDate(value){
	    const newEndDate = new Date();
	    setEndDate(newEndDate);  // 종료 날짜를 오늘로 설정
	    const newStartDate = new Date(newEndDate);
	    newStartDate.setDate(newEndDate.getDate() - value);
	    setStartDate(newStartDate);  // 시작 날짜를 조정
    }
    
	const setSearchData = (type:string) => {
		let param:any = {};

		param = {
			"LAST_STATUS": LAST_STATUS,
			"BIZ_CD" : BIZ_CD,
			"CORP_NM" : CORP_NM,
			"TSK_NM" : TSK_NM,
			"REG_DATE_S" : DateUtil.toDateFormat(StartDate, "YYYYMMDD"),
			"REG_DATE_E" : DateUtil.toDateFormat(EndDate, "YYYYMMDD"),
		};

		if(type === 'init'){
			//넘어온 파라미터 바인딩
			if(receivedData !== undefined && receivedData.PARAM_DATA !== undefined){
				param = JSON.parse(receivedData.PARAM_DATA);
				if(param.REG_DATE_S !== '') setStartDate(new Date(dateToStr(param.REG_DATE_S)));
				if(param.REG_DATE_E !== '') setEndDate(new Date(dateToStr(param.REG_DATE_E)));
				if(param.LAST_STATUS !== '') setLAST_STATUS(param.LAST_STATUS);
				if(param.BIZ_CD !== '') setBIZ_CD(param.BIZ_CD);
				if(param.CORP_NM !== '') setCORP_NM(param.CORP_NM);
				if(param.TSK_NM !== '') setTSK_NM(param.TSK_NM);
				rowCnt.current = receivedData.PARAM_ROW_CNT;
				setShowRowCnt(Number(rowCnt.current));
			}
		} else {
			pageNum.current = 1;
		}
		paramJson.current = JSON.stringify(param);

		paramSetting();

		return param;
	}	
	
    async function onClickSearch(sAction:string) {
		let param = {};
		param = setSearchData(sAction);
		
		const response:any = await CommonUtil.execute({
			url:"adm_7100_r001",
			data: param
        })
    	.then((response: any) => {
			if(sAction ==='init'){
				var delItems: {code: string; name: string;}[] = [];
				// @ts-ignore
				var delItem: {code: string; name: string;} = {};
		
		    	// @ts-ignore
				var rows = response.REC;
				for (var i = 0; i < Object.keys(response.REC).length; i++) {
			        delItem = {
			            code: rows[i]["CODE"],
			            name: rows[i]["NAME"],
			        };
		 	    	delItems.push(delItem);
			  	}
		
				// @ts-ignore
				setBIZ_SHORT_NM(delItems);				
				
			}
			
			totalCnt.current = Object.keys(response.REC2).length+'';
			setTotalRowCnt(Object.keys(response.REC2).length);
			
			ib.data = response.REC2;

	        // @ts-ignore
	        Main_sheet.loadSearchData(response.REC2);	
			// @ts-ignore
	        Main_sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			// @ts-ignore
			makePageIndex(Main_sheet.getPageIndex(Main_sheet.getFocusedPage()) + 1); // 페이지 초기화   			
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
    	});	        
     	
    };      
	/*
    async function onClickDetail() {
		// @ts-ignore
		var row = Main_sheet.getFocusedRow();
		var vPAY_REQ_NO = row["PAY_REQ_NO"];
		var vREG_DATE = row["REG_DATE"];
		var vREG_NUM = row["REG_NUM"];
		var vLAST_STATUS = row["LAST_STATUS"];
		var vLAST_SAN_YN = row["LAST_SAN_YN"];
		var vEXECUTE_YN = row["EXECUTE_YN"];
		var vAPPR_STAP_NO = row["APPR_STAP_NO"];
		var vBIZ_NO = row["BIZ_NO"];
		
		var sStartDate = StartDate;
		var sEndDate = EndDate;
		var sLAST_STATUS = LAST_STATUS;
		var sBIZ_CD = BIZ_CD;
		var sCORP_NM = CORP_NM;
		var sTSK_NM = TSK_NM;
				
	    let dataToSend = {vPAY_REQ_NO, vREG_DATE, vREG_NUM, vLAST_STATUS, vLAST_SAN_YN, vEXECUTE_YN, vAPPR_STAP_NO,vBIZ_NO,sStartDate,sEndDate,sLAST_STATUS,sBIZ_CD,sCORP_NM,sTSK_NM};
		paramStore.setParam("adm7101", dataToSend);

	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
			pathname: 'adm7101',
	    });

    };      
    */
    
	async function onClickAllAppr() {
		// @ts-ignore
		var Main_rows = Main_sheet.getDataRows();
		// @ts-ignore
		var delItems: { REG_DATE: string; REG_NUM: string; APPR_STAP_NO: string; SAN_STS: string; CURRENT_LINE_NO: string; LAST_STATUS: string;}[] = [];
		// @ts-ignore
		var delItem:  { REG_DATE: string; REG_NUM: string; APPR_STAP_NO: string; SAN_STS: string; CURRENT_LINE_NO: string; LAST_STATUS: string;} = {};
		
		var count = 0;
				
		for (var i = 0; i < Main_rows.length; i++) {
			if ( Main_rows[i]["chk"] ===  1 && Main_rows[i]["LAST_STATUS"] === 11){
				let vLAST_STATUS;
				let vCURRENT_LINE_NO;
				
				if ( Main_rows[i]["LAST_SAN_YN"] === 'Y'){
					vLAST_STATUS = '15';
					vCURRENT_LINE_NO = '0';
				} else {
					vLAST_STATUS = '10';
					vCURRENT_LINE_NO = '1';
				}			
				
		        delItem = {
		            REG_DATE: Main_rows[i]["REG_DATE"],
		            REG_NUM: Main_rows[i]["REG_NUM"],
		            APPR_STAP_NO: Main_rows[i]["APPR_STAP_NO"],
		            SAN_STS: "1",
		            CURRENT_LINE_NO: vCURRENT_LINE_NO,
		            LAST_STATUS: vLAST_STATUS,
				}
				delItems.push(delItem);
				count++;
			}
		}
		//console.log('count = ' + count);
		if( count === 0 ){
			UIUtils.alert('처리할 항목을 선택하세요.').then();
			return;
		}

		if(await UIUtils.confirm(count + '건 결재하시겠습니까?')){	
			const response:any = await CommonUtil.execute({
	            url:"adm_7100_u002",
	            data: {
					"REC" : delItems,
				}
	        })
        	.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then(()=>{
					onClickSearch('search');
				});
        	}).catch((error) => {
            	CommonUtil.showAxiosError(error);
            	return;
        	});
				
		}
	}; 	
	
	    
	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}
	
			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}
	
			// @ts-ignore
			currentPage = tp;
			
			let sr = Number(totalCnt.current) // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt.current; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / Number(page)); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			ul.style.textAlign = 'center';
	
			let k = 1;
	
			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
				
				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}
	
			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}
	
			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";	
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
				
				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}
	
			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			//console.log(ex.message);
		}
	}
	
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}
	
	const pageMove = function (cPage:number) {
		// @ts-ignore
		Main_sheet.goToPageByIndex(cPage);
	}
	
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			receivedData.PARAM_ROW_CNT = e.target.value;
			rowCnt.current = e.target.value;
			pageNum.current = 1;
			
		   	// @ts-ignore
		   	IBSheet.disposeAll(true);		  
		   	ib.init.Cfg.PageLength = e.target.value;
		   	ib.create();
		   
		}
	};
	     
    let SheetData_modal = {};
    let totalCnt_modal = useRef<number>(0);
	let defaultRowCnt_modal = 20;
	let rowCnt_modal = useRef<number>(20);

	var ib_modal = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": defaultRowCnt_modal,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",

			},
			
			"Cols": [
	            {"Header": "규모",		"Type": "Text",	"Name": "CORP_SIZE_NM",			"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {"Header": "사업자등록번호",	"Type": "Text",	"Name": "BIZ_NO",				"RelWidth": 1.5,	"Align": "left", 	"CanEdit": 0},
	            {"Header": "기업명",		"Type": "Text",	"Name": "CORP_NM",				"RelWidth": 2,		"Align": "left", 	"CanEdit": 0},
	            {"Header": "입금액",		"Type": "Int",	"Name": "SUM_IN_AMT",			"RelWidth": 2,		"Align": "Right",	"CanEdit": 0, "Format": "#,###"},
	            {"Header": "출금액",		"Type": "Int",	"Name": "SUM_OUT_AMT",			"RelWidth": 2, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###"},
	            {"Header": "잔액",		"Type": "Int",	"Name": "TOTAL_SUM_AMT",		"RelWidth": 2, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###"},
            ],      

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				onClickSearch_modal();
			},

			onAfterGotoPage:function (evtParam) {
				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
		        //@ts-ignore
				if (currentPage !== -1 && currentPage !== page) {
					makePageIndex_modal(page, totalCnt_modal.current);
				}
			},
			
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'Modal_sheet', // 생성할 시트의 id
				el: 'vacct_modal_List', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData_modal

			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.Modal_sheet.exportData({fileName: "기업별잔액조회_"+today+".xlsx", SheetDesign:3, excelRowHeight:16.5, excelFontSize:10, downCols: "Visible"});
		},

	}
	
    //검색
    async function onClickSearch_modal() {
		const response:any = await CommonUtil.execute({
            url:"adm_2110p_r001",
            data: {
				"BIZ_NO" : BIZ_NO_modal,
				"CORP_NM" : CORP_NM_modal,
			}
        })
    	.then((response: any) => {
			totalCnt_modal.current = Object.keys(response.REC).length;
			setTotalRowCnt_modal(totalCnt_modal.current);
			setSUM_IN_AMT_modal(response.TOTAL_SUM_IN_AMT);
			setSUM_OUT_AMT_modal(response.TOTAL_SUM_OUT_AMT);
			setTOTAL_SUM_AMT_modal(response.TOTAL_SUM_AMT);		
			
			SheetData_modal = response.REC;
			// @ts-ignore
	        Modal_sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        // @ts-ignore
	        Modal_sheet.loadSearchData(SheetData_modal);
	        // @ts-ignore
			makePageIndex_modal(Modal_sheet.getPageIndex(Modal_sheet.getFocusedPage()) + 1, Object.keys(response.REC).length); // 페이지 초기화
	        
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
    	});	        

    }; 
        
    async function onAfterOpen() {
        ib_modal.create();
        
		return () => {
	      // @ts-ignore
	    	IBSheet.disposeAll(true);
	    }            
	
	}
	
	async function onClose() {
	  setModalIsOpen(false);
	  SetBIZ_NO_modal('');
	  SetCORP_NM_modal('');
	  // @ts-ignore
	  IBSheet.Modal_sheet.dispose();
		
	}
	
  	const makePageIndex_modal = function (tp:number, vtotalCnt_modal:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}
	
			// @ts-ignore
			if (document.getElementById('pageNavi_modal').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi_modal').removeChild(document.getElementById('pageNavi_modal').firstChild);
			}
	
			// @ts-ignore
			currentPage = tp;
			
			let sr = vtotalCnt_modal // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt_modal.current; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			ul.style.textAlign = 'center';
	
			let k = 1;
	
			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler_modal(li, 'click', pageMove_modal, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
				
				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler_modal(li, 'click', pageMove_modal, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}
	
			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler_modal(li, 'click', pageMove_modal, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}
	
			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";	
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler_modal(li, 'click', pageMove_modal, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
				
				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler_modal(li, 'click', pageMove_modal, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}
	
			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi_modal').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			//console.log(ex.message);
		}
	}
	
	
	const addEventHandler_modal = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}
	
	
	const pageMove_modal = function (cPage:number) {
		// @ts-ignore
		Modal_sheet.goToPageByIndex(cPage);
	}
		
	const handleSelect_modal = (e) => {
		if(e.target.name === 'showRowCnt_modal'){
			setShowRowCnt_modal(e.target.value);
			rowCnt_modal.current = e.target.value;
		   	// @ts-ignore
		   	IBSheet.Modal_sheet.dispose();		  
		   	ib_modal.init.Cfg.PageLength = e.target.value;
		   	ib_modal.create();
		   
		}
	};	   

	const activeEnter = (e) => {
		if(e.key === "Enter") {
			onClickSearch('search')
		}
	}
		   
	const activeEnter_modal = (e) => {
		if(e.key === "Enter") {
			onClickSearch_modal()
		}
	}
		   
	useEffect(() => {
        // @ts-egnore
		ib.create();
		/*			
		if( receivedData !== undefined ){
			
			if(receivedData.searchData.REG_DATE_S !== undefined && receivedData.searchData.REG_DATE_S !== ''){
				const startDate = DateUtil.stringToDate(receivedData.searchData.REG_DATE_S,'YYYYMMDD');
				setStartDate(startDate!);
			}
			
			if(receivedData.searchData.REG_DATE_E !== undefined && receivedData.searchData.REG_DATE_E !== ''){
				const endDate = DateUtil.stringToDate(receivedData.searchData.REG_DATE_E,'YYYYMMDD');
				setEndDate(endDate!);
			}

			setLAST_STATUS(StringUtil.defaultString(receivedData.searchData.LAST_STATUS));
			setCORP_NM(StringUtil.defaultString(receivedData.searchData.CORP_NM));
			setTSK_NM(StringUtil.defaultString(receivedData.searchData.TSK_NM));
			setBIZ_CD(StringUtil.defaultString(receivedData.searchData.BIZ_CD));
			
			SetBIZ_NO_modal('');
			SetCORP_NM_modal('');
			
			onClickSearch('search', receivedData.searchData);		

		} else {
			StartDate.setDate(StartDate.getDate() - 30);
			setLAST_STATUS('');
			setCORP_NM('');
			setTSK_NM('');
			setBIZ_CD('');
			
			SetBIZ_NO_modal('');
			SetCORP_NM_modal('');
					
		}	
		*/
		if( receivedData === undefined ){
			StartDate.setDate(StartDate.getDate() - 30);
			setLAST_STATUS('');
			setCORP_NM('');
			setTSK_NM('');
			setBIZ_CD('');
			
			SetBIZ_NO_modal('');
			SetCORP_NM_modal('');			
		}
		
        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);
        }
    },[])	
    	
	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li><Link to="/admin/">홈</Link></li>
						<li><Link to="#">관리자페이지</Link></li>
						<li><Link to="#">결재함</Link></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">결재함</h1>
						<div className="sf sf-3col">
							<div className="inner">
								<div className="sf-item sf-m-1-3">
									<p className="sf-key">등록일</p>
									<div className="sf-value">
									<div className="fund-datepicker">
										<div className="hz-root hz-gap5">
												<UIDatePicker className="hz-item" value={StartDate} valueChanged={(value) => setStartDate(value)}/>
												<span className="hz-item">~</span>
												<UIDatePicker className="hz-item" value={EndDate} valueChanged={(value) => setEndDate(value)}/>
											</div>
											<div className="hz-item hz-root hz-gap5">
												<button className="bt" data-color={dateNum === 1 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(0); setDateNum(1);}}>오늘</button>
												<button className="bt" data-color={dateNum === 2 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(7); setDateNum(2);}}>1주일</button>
												<button className="bt" data-color={dateNum === 3 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(30); setDateNum(3);}}>1개월</button>
												<button className="bt" data-color={dateNum === 4 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(90); setDateNum(4);}}>3개월</button>
												<button className="bt" data-color={dateNum === 5 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(180); setDateNum(5);}}>6개월</button>
												<button className="bt" data-color={dateNum === 6 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(365); setDateNum(6);}}>1년</button>
											</div>
										</div>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">결재상태</p>
									<div className="sf-value">
										<div className="sl sl-md w100p">
											<UISelect
									        	className=""
									        	firstName={"all"}
									        	value={LAST_STATUS}
									        	valueChanged={(value) => setLAST_STATUS(value)}
									        	codeData={[
													{ code: '10', name: '결재중' },
													{ code: '15', name: '전결' },
													{ code: '32', name: '반려' },
													{ code: '20', name: '집행요청' },
													{ code: '51', name: '집행처리중' },
													{ code: '52', name: '집행완료' },
												]}
									      	/>										
										</div>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">사업명</p>
									<div className="sf-value">
										<div className="sl sl-md w100p">
											<UISelect
									        	className=""
									        	firstName={"all"}
									        	value={BIZ_CD}
									        	valueChanged={(value) => setBIZ_CD(value)}
									        	codeData={BIZ_SHORT_NM}
									      	/>	
										</div>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">출연기업</p>
									<div className="sf-value">
										<UIInput className={'tf tf-md w100p'} value={CORP_NM} placeholder={''} valueChanged={(value) => setCORP_NM(value)} onKeyEnter={(e) => activeEnter(e)}/>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">과제명</p>
									<div className="sf-value">
										<UIInput className={'tf tf-md w100p'} value={TSK_NM} placeholder={''} valueChanged={(value) => setTSK_NM(value)} onKeyEnter={(e) => activeEnter(e)}/>
									</div>
								</div>
							</div>
						</div>
						<div className="hz-root hz-center mb30">
							<button className="bt" data-color="pri" data-size="md" type="button" onClick={()=> onClickSearch('search')}>조회</button>
						</div>

						<div className="tb-top">
							<div className="hz-root hz-gap15">
								<div className="hz-item">
									<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
								</div>
							</div>
							<div className="hz-root hz-gap5">
								<Button color="pri-o" size="sm" onClick={onClickAllAppr}>일괄결재</Button>
								<Button color="pri-o" size="sm" onClick={() => setModalIsOpen(true)}>기업별 잔액조회</Button>
								<Button color="gray-o" size="sm" onClick={()=> ib.exportData()}>다운로드</Button>
								<div className="sl sl-sm w120">
									<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
										<option value="20">20개씩보기</option>
										<option value="50">50개씩보기</option>
										<option value="100">100개씩보기</option>
										<option value="200">200개씩보기</option>
										<option value="500">500개씩보기</option>
										<option value="1000">1000개씩보기</option>
									</select>
								</div>
							</div>
						</div>
						<div className="ibsheet" id='ap_trade_mast'></div>
						<div id="pageNavi" className="pg"></div>
					</main>

				</div>
			{/* modal - 2110 */}
			<ModalPopup
				open={modalIsOpen}
				title="기업별 잔액조회"
				size="lg"
				onClose={() => onClose()}
				onAfterOpen={() => onAfterOpen()}
			>
				<div className="modal-con">

					<form className="sf sf-1row sf-2col mb30">
						<div className="inner">
							<div className="sf-item">
								<p className="sf-key">사업자등록번호</p>
								<div className="sf-value">
									<UIInput
										className={'tf tf-md w100p'}
										value={BIZ_NO_modal}
										valueChanged={(value) => SetBIZ_NO_modal(value)}
										placeholder={''}
										type='number'
										onKeyEnter={(e) => activeEnter_modal(e)}
									/>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">기업명</p>
								<div className="sf-value">
									<UIInput
										className={'tf tf-md w100p'}
										value={CORP_NM_modal}
										valueChanged={(value) => SetCORP_NM_modal(value)}
										placeholder={''}
										onKeyEnter={(e) => activeEnter_modal(e)}
									/>
								</div>
							</div>
						</div>
						<button className="bt" data-color="pri" data-size="md"  type="button" onClick={onClickSearch_modal}>조회</button>
					</form>

					<div className="tb-top">
							<div className="hz-root hz-gap15">
								<div className="hz-item">
									<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt_modal}</em>건
								</div>
								<div className="hz-item">
									<em className="fc-err">입금액</em> <span className="price">{SUM_IN_AMT_modal}</span>원
										&nbsp;- &nbsp;
									<em className="fc-pri">출금액</em>  <span className="price">{SUM_OUT_AMT_modal}</span>원
										&nbsp;= &nbsp;
									<em className="fc-black">합계</em> <span className="price">{TOTAL_SUM_AMT_modal}</span>원
								</div>

							</div>
							<div className="hz-root hz-gap5">
								<Button color="gray-o" size="sm" onClick={()=> ib_modal.exportData()}>다운로드</Button>
								<div className="sl sl-sm w120">
									<select name="showRowCnt_modal" id="showRowCnt_modal" className="" value={showRowCnt_modal} onChange={(handleSelect_modal)}>
										<option value="20">20개씩보기</option>
										<option value="50">50개씩보기</option>
										<option value="100">100개씩보기</option>
										<option value="200">200개씩보기</option>
										<option value="500">500개씩보기</option>
										<option value="1000">1000개씩보기</option>
									</select>
								</div>
							</div>
						</div>
					<div id='vacct_modal_List'></div>
					<div id="pageNavi_modal" className="pg"></div>
				</div>
			</ModalPopup>				
		</PageContainer>
	);
}
export default ContentsContainer;